import React from 'react';
import LoanInstallmentTableSC from './loan-installment-table.styled';
import { SmallText } from '../../typography';
import LoanInstallmentItem from './loan-installment-item';
import dlt from '../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';
import useWindowSize from '../../../utils/screen-size';
import { BP_TABLET_MIN } from '../../../assets/styles/breakpoints';

const LoanInstallmentTable = ({ loans, sales, dueInstallmentCount }) => {
  const screenSize = useWindowSize();
  const isTablet = screenSize.width < BP_TABLET_MIN;

  const formatStatus = (name, installment) => {
    if (name === 'sale') {
      return 'sale';
    }
    if (name === 'loan' && installment[0] <= dueInstallmentCount) {
      if (Number(installment[12]) === 0) {
        return 'done';
      } else {
        return 'late';
      }
    }
    return 'pending';
  };

  return (
    <>
      <LoanInstallmentTableSC>
        {isTablet ? null : (
          <thead>
            <tr>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_loan_detail_installment_table_head_1"
                    defaultMessage={dlt['investor_loan_detail_installment_table_head_1']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_loan_detail_installment_table_head_4"
                    defaultMessage={dlt['investor_loan_detail_installment_table_head_4']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_loan_detail_installment_table_head_2"
                    defaultMessage={dlt['investor_loan_detail_installment_table_head_2']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_loan_detail_installment_table_head_3"
                    defaultMessage={dlt['investor_loan_detail_installment_table_head_3']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_loan_detail_installment_table_head_6"
                    defaultMessage={dlt['investor_loan_detail_installment_table_head_6']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_loan_detail_installment_table_head_5"
                    defaultMessage={dlt['investor_loan_detail_installment_table_head_5']}
                  />
                </SmallText>
              </th>
            </tr>
          </thead>
        )}

        <tbody>
          {loans !== null
            ? loans.map((item) => {
                return (
                  <LoanInstallmentItem
                    key={item[0]}
                    date={item[1]}
                    principal={item[3]}
                    interest={item[4]}
                    total={item[2]}
                    days={item[12]}
                    status={formatStatus('loan', item)}
                    isTablet={isTablet}
                    paidDays={item[11]}
                  />
                );
              })
            : null}
          {sales !== null
            ? sales.map((item) => {
                return (
                  <LoanInstallmentItem
                    key={item.schedule[0]}
                    date={item.schedule[1]}
                    principal={item.schedule[3]}
                    interest={item.schedule[4]}
                    total={item.schedule[2]}
                    price={item.price}
                    status={formatStatus('sale', item)}
                    isTablet={isTablet}
                    paidDays={item.schedule[11]}
                  />
                );
              })
            : null}
        </tbody>
      </LoanInstallmentTableSC>
    </>
  );
};

export default LoanInstallmentTable;
